import { render, staticRenderFns } from "./AutomaticInvestment.vue?vue&type=template&id=bdcee1f4&scoped=true&"
import script from "./AutomaticInvestment.vue?vue&type=script&lang=js&"
export * from "./AutomaticInvestment.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdcee1f4",
  null
  
)

export default component.exports